<template>
  <div id="app" data-qa="app-page" class="is-fullheight">
    <main-component />
  </div>
</template>

<script setup lang="ts">
import MainComponent from '@/views/MainComponent.vue';
import Utils from 'ui-component-library/helpers/Utils';
import { useContextStore } from './store/ContextStore';
import { onMounted } from 'vue';

const contextStore = useContextStore();

window.addEventListener('pagehide', () => {
  if (!sessionStorage.getItem('redirectingToLogin')) {
    Utils.clearSessionData();
  }
  sessionStorage.removeItem('redirectingToLogin');
});

onMounted(() => {
  if (!contextStore.isShell && !contextStore.isMicroFrontend) {
    contextStore.initializeAsSPA();
  }
});
</script>
